import React, { useState, useEffect, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import { Container, Row } from "react-bootstrap";
import Chemist from "../Assets/lab_chem.jpg";
import DrPatient from "../Assets/Dr_patient.jpg";
import HappyPatient from "../Assets/happy_patient.jpg";
import OverviewExtend from "./addOverview";
import Footer from "./footer";
import "./overview.css";

const slides = [
    {
        image: Chemist,
        tag: "Research & Development",
        heading: ["Collaboration in", <em key="e"> Innovation</em>],
        text: "Together, we create the future of healthcare — one breakthrough at a time. In the pursuit of medical excellence, dedicated professionals combine expertise to develop treatments that transform patient care."
    },
    {
        image: DrPatient,
        tag: "Patient First",
        heading: ["Compassionate", <em key="e"> Care</em>],
        text: "Every patient deserves a dedicated partner in their journey to health. A doctor's role extends beyond diagnosis — it embodies empathy, trust, and understanding that empowers patients to thrive."
    },
    {
        image: HappyPatient,
        tag: "Outcomes & Wellness",
        heading: ["The Joy of", <em key="e"> Healing</em>],
        text: "Health is not merely the absence of illness — it is the presence of happiness and well-being. Seeing patients recover and flourish is the ultimate reward for everyone at Asava Pharmaceuticals."
    }
];

const INTERVAL = 6000;

const Overview = () => {
    const [current, setCurrent] = useState(0);
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);
    const progressRef = useRef(null);
    const startTimeRef = useRef(null);

    const goTo = (index) => {
        setCurrent((index + slides.length) % slides.length);
        setProgress(0);
        startTimeRef.current = Date.now();
    };

    const next = () => goTo(current + 1);
    const prev = () => goTo(current - 1);

    
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setCurrent(c => (c + 1) % slides.length);
            setProgress(0);
            startTimeRef.current = Date.now();
        }, INTERVAL);
        return () => clearInterval(intervalRef.current);
    }, [current]);

   
    useEffect(() => {
        startTimeRef.current = Date.now();
        const tick = () => {
            const elapsed = Date.now() - startTimeRef.current;
            setProgress(Math.min((elapsed / INTERVAL) * 100, 100));
            progressRef.current = requestAnimationFrame(tick);
        };
        progressRef.current = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(progressRef.current);
    }, [current]);

    return (
        <div className="overview-page">
            <Helmet>
                <title>Company Overview | Asava Pharmaceutical Pvt Ltd</title>
                <meta name="description" content="Learn about Asava Pharmaceutical Pvt Ltd — a growing pharma company in Lucknow, UP, dedicated to delivering quality medicines across Uttar Pradesh and India." />
                <link rel="canonical" href="https://www.asavapharma.in/overview" />
            </Helmet>

            <div className="overview-carousel-section">
                {slides.map((slide, i) => (
                    <div
                        key={i}
                        className={`overview-slide ${i === current ? 'active' : ''}`}
                    >
                        <img
                            src={slide.image}
                            alt={slide.tag}
                            className="overview-slide-img"
                        />
                        <div className="overview-slide-overlay" />
                        <div className="overview-slide-content">
                            <div className="overview-slide-tag">{slide.tag}</div>
                            <h2 className="overview-slide-heading">{slide.heading}</h2>
                            <p className="overview-slide-text">{slide.text}</p>
                        </div>
                    </div>
                ))}

              
                <div className="overview-dots">
                    {slides.map((_, i) => (
                        <button
                            key={i}
                            className={`overview-dot ${i === current ? 'active' : ''}`}
                            onClick={() => goTo(i)}
                        />
                    ))}
                </div>

                
                <div className="overview-counter">
                    <span className="overview-counter-current">
                        0{current + 1}
                    </span>
                    <div className="overview-counter-sep" />
                    <span className="overview-counter-total">
                        0{slides.length}
                    </span>
                </div>

                
                <div className="overview-arrows">
                    <button className="overview-arrow" onClick={prev}>‹</button>
                    <button className="overview-arrow" onClick={next}>›</button>
                </div>

               
                <div className="overview-progress">
                    <div
                        className="overview-progress-bar"
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>

         
            <div className="overview-stats">
                <div className="overview-stat">
                    <div className="overview-stat-number">6+</div>
                    <div className="overview-stat-label">Products Launched</div>
                </div>
                <div className="overview-stat">
                    <div className="overview-stat-number">100%</div>
                    <div className="overview-stat-label">Quality Assured</div>
                </div>
                <div className="overview-stat">
                    <div className="overview-stat-number">2</div>
                    <div className="overview-stat-label">Expert Directors</div>
                </div>
            </div>

            
            <OverviewExtend />

            
            <Container fluid style={{ padding: 0 }}>
                <Row className="overview-footer-row">
                    <Footer />
                </Row>
            </Container>
        </div>
    );
};

export default Overview;